//
// Copyright (c) 2011 - 2011-2017 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

const curalate = angular.module('curalate');

curalate.service('AssistedProductTaggingService', [
  '$http',
  'rx',
  'PromiseService',
  'SessionVarsService',
  function ($http, rx, PromiseService, SessionVarsService) {
    const IPT_GATEWAY_URL = CURALATE_ENV.IPT_GATEWAY_URL;
    const IPT_BASE_ENDPOINT = '/api/v1/ipt';
    const IPT_BASE_ENDPOINT_V2 = '/api/v2/ipt';
    const cachedRelevancyData = {};
    const cachedRelevancyPromises = {};
    const productRelevancyDataStream = new rx.BehaviorSubject();

    const convertX2Y2ToWidthHeight = function (coordinates) {
      return {
        x: coordinates.x1,
        y: coordinates.y1,
        width: coordinates.x2 - coordinates.x1,
        height: coordinates.y2 - coordinates.y1,
      };
    };

    const isIntelligentProductTaggingV2Enabled =
      SessionVarsService.isFeatureEnabled(
        FeatureNames.IntelligentProductTaggingV2,
      );

    // TODO: PD-301920 - Cleanup IPT v1 API calls once IPTv2 GAed
    this.getProductRelevancyDataSubjectV1 = function (itemId) {
      if (!cachedRelevancyData[itemId] && !cachedRelevancyPromises[itemId]) {
        cachedRelevancyPromises[itemId] = PromiseService.processHttpResponse(
          $http.get(`${IPT_GATEWAY_URL}${IPT_BASE_ENDPOINT}/search/${itemId}`),
        ).then((result) => {
          _(result.boundingBoxes).each((boundingBox) => {
            boundingBox.coordinates = convertX2Y2ToWidthHeight(
              boundingBox.coordinates,
            );
          });

          cachedRelevancyData[itemId] = result;
          productRelevancyDataStream.next({
            itemId,
            relevancyData: cachedRelevancyData[itemId],
          });
        });
      }

      return productRelevancyDataStream.filter(
        (data) => data?.itemId === itemId,
      );
    };

    this.getProductRelevancyDataSubjectV2 = function (itemId) {
      if (!cachedRelevancyData[itemId] && !cachedRelevancyPromises[itemId]) {
        cachedRelevancyPromises[itemId] = PromiseService.processHttpResponse(
          $http.get(
            `${IPT_GATEWAY_URL}${IPT_BASE_ENDPOINT_V2}/search/${itemId}`,
          ),
        ).then((result) => {
          _(result.boundingBoxes).each((boundingBox) => {
            boundingBox.coordinates = convertX2Y2ToWidthHeight(
              boundingBox.coordinates,
            );
          });

          cachedRelevancyData[itemId] = result;
          productRelevancyDataStream.next({
            itemId,
            relevancyData: cachedRelevancyData[itemId],
          });
        });
      }

      return productRelevancyDataStream.filter(
        (data) => data?.itemId === itemId,
      );
    };

    // TODO: PD-301920 - Cleanup IPT v1 API calls once IPTv2 GAed
    this.getProductRelevancyDataSubject = function (itemId) {
      if (isIntelligentProductTaggingV2Enabled) {
        return this.getProductRelevancyDataSubjectV2(itemId);
      }

      return this.getProductRelevancyDataSubjectV1(itemId);
    };

    this.getCachedBoundingBox = function (itemId, boxId) {
      const productRelevancyBoxes =
        cachedRelevancyData &&
        cachedRelevancyData[itemId] &&
        cachedRelevancyData[itemId].boundingBoxes;
      return _(productRelevancyBoxes).findWhere({ boxId });
    };

    this.linkProductToBoundingBoxAsync = function (
      itemId,
      boxId,
      productStyleId,
    ) {
      const params = {
        networkItemId: itemId,
        boxId,
        productId: productStyleId,
      };
      return PromiseService.processHttpResponse(
        $http.post(`${IPT_GATEWAY_URL}${IPT_BASE_ENDPOINT}/link`, params),
      ).then((response) => {
        response.coordinates = convertX2Y2ToWidthHeight(response.coordinates);

        cachedRelevancyData[itemId].boundingBoxes = _(
          cachedRelevancyData[itemId].boundingBoxes,
        ).reject((boundingBox) => boundingBox.boxId === response.boxId);

        cachedRelevancyData[itemId].boundingBoxes.push(response);
        productRelevancyDataStream.next({
          itemId,
          relevancyData: cachedRelevancyData[itemId],
        });

        return response;
      });
    };

    this.getBoundingBoxByProductStyleId = function (itemId, productStyleId) {
      const productRelevancyBoxes =
        cachedRelevancyData &&
        cachedRelevancyData[itemId] &&
        cachedRelevancyData[itemId].boundingBoxes;
      return _(productRelevancyBoxes).find(
        (product) =>
          _(product).safeGet('selectedProduct.productStyleId') ===
          productStyleId,
      );
    };

    this.saveFeedbackAsync = function (itemId, boxId, thumbsUp) {
      const params = {
        networkItemId: itemId,
        thumbsUp,
        boxId,
      };

      return PromiseService.processHttpResponse(
        $http.post(
          `${IPT_GATEWAY_URL}${IPT_BASE_ENDPOINT}/user-feedback`,
          params,
        ),
      );
    };
  },
]);
